<mat-card>
  <mat-card-content>
    <form [formGroup]="_filterForm">
      <div class="flex-container">
        <mat-form-field class="form-field">
          <mat-select formControlName="orderTypeID" [placeholder]="'common.labels.orderType' | transloco">
            @for (option of _orderTypes; track option) {
              <mat-option [value]="option.value">
                {{ option.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <lib-jurisdiction-selection (formReady)="jurisdictionFormChanges($event)" [defaultCountry]="'CA'"></lib-jurisdiction-selection>

      <div>
        <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.clearFiltersButton' | transloco" type="button"
          (click)="onClear()" [disabled]="!_filterForm.dirty">
          {{ 'common.labels.clearFilters' | transloco }}
        </button>
        <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.filterButton' | transloco" type="submit"
          (click)="onFilter()">
          {{ 'common.labels.filter' | transloco }}
        </button>
      </div>
    </form>
  </mat-card-content>
</mat-card>